import { styled } from 'styled-components';

export const Errors = styled.svg`
 
position: absolute;
    top: 27%;
    right: 8%;
    @media screen and (min-width: 375px) {
        
    }
    @media screen and (min-width: 768px) {
       
    }
`;